module.exports = __webpack_public_path__ + "img/tug-boat-icon.c12f39d6.svg";